module.exports = __webpack_public_path__ + "img/bendera Indonesia-08-min.720a40c7.png";